module.exports = __webpack_public_path__ + "static/media/readytoflylogosmall.afe7dc35.png";